import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { COMPANY } from "../lib/company";
import { PUBLIC_ROUTES } from "../lib/routes";

/** Keep in-app navigation consistent with the metadata in pre-rendered HTML. */
export function PublicMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const route = PUBLIC_ROUTES.find(item => item.path === (pathname.replace(/\/+$/, "") || "/"));
    document.querySelector('meta[name="robots"]')?.setAttribute("content", route ? "index, follow" : "noindex, follow");
    if (!route) return;
    document.title = route.title;
    const values: [string, string][] = [
      ['meta[name="description"]', route.description],
      ['meta[name="twitter:title"]', route.ogTitle ?? route.title],
      ['meta[name="twitter:description"]', route.ogDescription ?? route.description],
      ['meta[property="og:title"]', route.ogTitle ?? route.title],
      ['meta[property="og:type"]', route.ogType ?? "website"],
      ['meta[property="og:description"]', route.ogDescription ?? route.description],
      ['meta[property="og:url"]', COMPANY.site + route.path],
      ['meta[property="og:image"]', COMPANY.site + (route.ogImage ?? "/og-image.png")],
      ['meta[name="twitter:image"]', COMPANY.site + (route.ogImage ?? "/og-image.png")],
    ];
    for (const [selector, value] of values) document.querySelector(selector)?.setAttribute("content", value);
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", COMPANY.site + route.path);
  }, [pathname]);
  return null;
}
